import { Dropdown, ButtonGroup } from 'react-bootstrap'
import Link from 'next/link'
import { useState, useEffect, useRef } from 'react';
import { useRouter } from "next/router";
import { FaCaretDown } from "react-icons/fa"

export default function TabMenu({active}){
    const classes = "text-reset border-0 rounded-0 bg-transparent px-4 pb-3"
    const [isSticky, setSticky] = useState(false);
    const ref = useRef(null);
    const handleScroll = () => {
      if (ref.current) {
        setSticky(ref.current.getBoundingClientRect().top <= 47);
      }
    };
  
    useEffect(() => {
      window.addEventListener('scroll', handleScroll);
  
      return () => {
        window.removeEventListener('scroll', () => handleScroll);
      };
    }, []);
    
    const router = useRouter();
    
    let dropdownTitle = null;
    
    switch(router.pathname) {
        case '/learn-and-earn/activity':
            dropdownTitle = 'Activity';
            break;
        case '/learn-and-earn/badges':
            dropdownTitle = 'Badges';
            break;
        case '/learn-and-earn/points':
            dropdownTitle = 'Points';
            break;
        default:
            dropdownTitle = 'Overview';
    }
    
    return(
        
        <div className={`sticky-wrapper text-center position-sticky zindex-1 pt-lg-3 pt-1 pb-lg-0 pb-1 ${isSticky ? ' sticky' : ''}`} ref={ref}>

            <div className="d-lg-block d-none">
                <Link href="/learn-and-earn/overview" passHref><a className={`${classes} ${active === 'overview' ? 'active' : null } button`}>Overview</a></Link>
                <Link href="/learn-and-earn/activity" passHref><a className={`${classes} ${active === 'activity' ? 'active' : null } button`}>Activity</a></Link>
                <Link href="/learn-and-earn/badges" passHref><a className={`${classes} ${active === 'badges' ? 'active' : null } button`}>Badges</a></Link>
                <Link href="/learn-and-earn/points" passHref><a className={`${classes} ${active === 'points' ? 'active' : null } button`}>Points</a></Link>
            </div>

            <div className="d-lg-none d-block">
                <Dropdown as={ButtonGroup} size="lg">
                    <Dropdown.Toggle>{dropdownTitle} <FaCaretDown /></Dropdown.Toggle>
                    <Dropdown.Menu>
                        <Dropdown.Item href="/learn-and-earn/overview">Overview</Dropdown.Item>
                        <Dropdown.Item href="/learn-and-earn/activity">Activity</Dropdown.Item>
                        <Dropdown.Item href="/learn-and-earn/badges">Badges</Dropdown.Item>
                        <Dropdown.Item href="/learn-and-earn/points">Points</Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown>
            </div>

            <style jsx global>

                {`
                    .button{
                        display:inline-block;
                        text-decoration: none;
                    }
                    .button:hover{
                        text-decoration: none;
                    }
                    .button.active{
                        border-bottom:2px solid #43a649!important;
                    }
                    .sticky-wrapper{
                        background-color: #f7f7f7;
                    }
                    .sticky-wrapper button:not(:disabled):not(.disabled) {
                        background: #f5f5f5;
                        border: 1px solid #f5f5f5;
                        color: #1b1b1b;
                    }
                    .sticky {
                        box-shadow: 0 5px 5px -5px #333;
                    }

                    @media (max-width: 991.98px) {

                        .sticky {
                            top: 47px;
                        }

                    }

                `}

            </style>
        </div>
       
    )
}